import { Injectable, Injector } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ProductionJobSharedDetailResourceToProductionJobSharedDetailMapper } from '../models/mappers/production-job-shared-detail-resource-to-production-job-shared-detail.mapper';
import { ProductionJobSharedDetailResource } from '../models/resource/production-job-shared-detail.resource';
import { ProductionJobSharedDetail } from '../models/ui/production-job-shared-detail.model';
import { AppConfigService } from '../services/app-config.service';
import { SdkBase } from '../utilities/sdk-base/sdk.base';

const mapper = new ProductionJobSharedDetailResourceToProductionJobSharedDetailMapper();

@Injectable({
	providedIn: 'root'
})
export class ProductionJobDownloadSharedSdk extends SdkBase {
	constructor(injector: Injector, private appConfigService: AppConfigService) {
		super(injector);
	}

	public getProductionJobBySharedId(sharedId: string): Observable<ProductionJobSharedDetail> {
		return this.makeHttpRequest<ProductionJobSharedDetailResource>('get', `api2/ProductionJobShared/${sharedId}`).pipe(
			map((response) => {
				return mapper.map(response);
			})
		);
	}
}
